module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "bk"
    }
  }, [_c('h1', {
    staticClass: "bk"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "piii"
    }
  }), _vm._v("The Psalms as Christian Lament")]), _vm._v(" "), _c('h1', {
    staticClass: "bk1"
  }, [_vm._v("A Historical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("Bruce K. Waltke, James M. Houston, and Erika Moore")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_vm._v("W"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ILLIAM")]), _vm._v(" B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" E"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ERDMANS")]), _vm._v(" P"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("UBLISHING")]), _vm._v(" C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OMPANY")])]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_vm._v("G"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("RAND")]), _vm._v(" R"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("APIDS,")]), _vm._v(" M"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ICHIGAN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("/")]), _vm._v(" C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AMBRIDGE,")]), _vm._v(" U"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("K"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59d0e310","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-psalmschristian-0003.vue
// module id = 60
// module chunks = 0